import { instance } from '@rsos/sinatra';
import { getAPIHost } from '@rsos/utils/metaTags';

const baseURL = `${getAPIHost()}/v1/capstone/psaps`;

export const getAgencyLinks = async org =>
  instance.get(`${baseURL}/${org}/agency-link?link_type=alerts`, {
    headers: { retry: true },
  });

export const getAgencies = data => {
  let url = `${baseURL}/${data.org}/agency-link/authorities?link_type=alerts`;
  return instance.get(url, { headers: { retry: true } });
};

export const postAgency = data =>
  instance.post(`${baseURL}/${data.org}/agency-link`, data, {
    headers: { retry: true },
  });

export const patchAgency = data =>
  instance.patch(
    `${baseURL}/${data.org}/agency-link/${data.id}?link_type=alerts`,
    {
      status: data.status,
      alert_emergency_types: data.alert_emergency_types,
    },
    { headers: { retry: true } },
  );

export const deleteAgency = data =>
  instance.delete(
    `${baseURL}/${data.org}/agency-link/${data.id}?link_type=alerts`,
    {
      headers: { retry: true },
    },
  );
